<template>
    <v-card ref="applicantsManager" id="applicantsManager">
        <v-card-title>
            Applicants Management
        </v-card-title>
        <v-card-subtitle class="pt-3">
            <v-icon :color="subAppColor">mdi-account-search</v-icon> Advanced Search
        </v-card-subtitle>
        <v-card-text>
            <v-form ref="applicantsManagerSearch">
                <v-select v-model="residenceTerm" class="pt-3" :items="getResidenceTerms" label="Residence Term"
                    placeholder="Please select.." prepend-icon="mdi-calendar-range" @change="searchApplicant()">
                </v-select>
                <v-text-field v-model="searchTerm" class="pb-3" prepend-icon="mdi-magnify" single-line hide-details
                    label="Search" type="text" @keydown.enter="searchApplicant()">
                </v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn ref="searchBtn" class="white--text" :color="primaryColor" @click="searchApplicant()">
                Search
            </v-btn>
            <v-btn ref="resetBtn" :color="warningColor" @click="resetApplicant()">
                Reset
            </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-subtitle class="pb-0">
            <v-icon :color="subAppColor">mdi-account-multiple</v-icon> Applicants
        </v-card-subtitle>
        <v-card-title class="pt-0">
            <v-spacer>
            </v-spacer>
            <v-text-field v-model="filterTerm" prepend-inner-icon="mdi-filter" clearable hide-details
                label="Filter Term (Optional)" single-line>
            </v-text-field>
        </v-card-title>
        <v-card-text>
            <v-data-table :headers="applicantsHeader" :items="data" :search="filterTerm" sort-by="name">
                <template v-slot:item.actions="{ item }">
                    <v-btn @click="openDialogEdit(item)" :color="warningColor" icon>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-account-edit
                                </v-icon>
                            </template>
                            <span>Edit Applicant</span>
                        </v-tooltip>
                    </v-btn>
                    <v-btn :disabled="!item.roiExists || item.roiExists.exists != '1'"
                        @click="openReleaseOfInformation(item)" :color="infoColor" icon>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-text-box
                                </v-icon>
                            </template>
                            <span>View Release of Information</span>
                        </v-tooltip>
                    </v-btn>
                    <v-btn @click="openDialog(item)" :color="successColor" icon>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">
                                    mdi-card-account-details
                                </v-icon>
                            </template>
                            <span>View Applicant</span>
                        </v-tooltip>
                    </v-btn>
                </template>
                <template v-slot:item.getApplicantRole="{ item }">
                    {{ getApplicantRole(item) }}
                </template>
                <template v-slot:item.getPrinted="{ item }">
                    <v-chip dark :color="getPrintedColor(item)" small>
                        {{ getPrintedLabel(item) }}
                    </v-chip>
                </template>
                <template v-slot:item.getStatus="{ item }">
                    <v-chip dark :color="getStatusColor(item)" small>
                        {{ getStatusLabel(item) }}
                    </v-chip>
                </template>
            </v-data-table>
            <applicant-edit v-if="getAccess()" ref="applicantEdit" :dialog="dialogEdit" :avatar="currentAvatar"
                :formSettings="formSettings" :item="currentItem" :permission="permission"
                :residenceTermsAppliedTo="residenceTermsAppliedTo" @addTrainingDayMissed="addTrainingDayMissed"
                @closeDialogEdit="closeDialogEdit" @getCurrentApplicant="getCurrentApplicant"
                @editApplicant="editApplicant" @refreshData="refreshData"
                @removeTrainingDayMissed="removeTrainingDayMissed" @resetBuildingOption1="resetBuildingOption1"
                @resetBuildingOption2="resetBuildingOption2" @resetRoommateOption1="resetRoommateOption1"
                @resetRoommateOption2="resetRoommateOption2" @setNotification="setNotification"></applicant-edit>
            <applicant-information ref="applicantInformation" :dialog="dialog" :avatar="currentAvatar"
                :item="currentItem" :permission="permission" @closeDialog="closeDialog"
                @getCurrentApplicant="getCurrentApplicant" @refreshData="refreshData"
                @setNotification="setNotification">
            </applicant-information>
        </v-card-text>
    </v-card>
</template>

<script>
import ApplicantEdit from './Edit';
import ApplicantInformation from './Information';

export default {
    name: 'applicants-manager',
    components: {
        ApplicantEdit,
        ApplicantInformation
    },
    props: {
        data: {
            required: true,
            type: Array
        },
        permission: {
            required: true,
            type: Object
        },
        residenceTermDefault: {
            required: true
        },
        residenceTerms: {
            required: true
        },
        searchBool: {
            required: true
        }
    },
    data() {
        return {
            applicantsHeader: [{
                    text: 'Student Number',
                    align: 'start',
                    value: 'studentnumber',
                },
                {
                    text: 'Surname',
                    value: 'lastName'
                },
                {
                    text: 'Name',
                    value: 'firstName'
                },
                {
                    text: 'Applicant Role',
                    value: 'getApplicantRole'
                },
                {
                    text: 'Residence Term',
                    value: 'residenceTerm'
                },
                {
                    sortable: false,
                    text: 'Printed',
                    value: 'getPrinted'
                },
                {
                    sortable: false,
                    text: 'Status',
                    value: 'getStatus'
                },
                {
                    sortable: false,
                    text: 'Actions',
                    value: 'actions',
                }
            ],
            currentAvatar: '',
            currentItem: '',
            dialog: false,
            dialogEdit: false,
            filterTerm: '',
            formSettings: {
                mealPlans: []
            },
            residenceTerm: '',
            residenceTermsAppliedTo: [],
            searchTerm: ''
        }
    },
    methods: {
        addTrainingDayMissed(item) {
            this.currentItem.trainingDaysMissed.push(item);
        },
        closeDialog() {
            this.dialog = false;
        },
        closeDialogEdit() {
            this.dialogEdit = false;
        },
        async getAvatar(studentnumber) {
            // Load image
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/snapshot-api/api.service.pl`;

            // Parse array into string
            formData.append('data', JSON.stringify({
                fallback: 1,
                studentnumber: studentnumber
            }));
            formData.append('mode', 'getPhoto');

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'Token': '5dfac020a2044e28787a7693d36b8874874c713fccc078aa148b100500b97229ff5848550d59a5e9fed942d9c40e89cc33b3eeca302043c51d997ced6899dae2',
                        'Content-Type': 'multipart/form-data'
                    },
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        if (json.data && json.data.image && json.data.image.image) {
                            that.currentAvatar = json.data.image.image;
                        }
                    }

                    if (that.$refs.applicantEdit) {
                        that.$refs.applicantEdit.setAvatarLoad(false);
                    }

                    if (that.$refs.applicantInformation) {
                        that.$refs.applicantInformation.setAvatarLoad(false);
                    }
                })
                .catch(function () {
                    if (that.$refs.applicantEdit) {
                        that.$refs.applicantEdit.setAvatarLoad(false);
                    }

                    if (that.$refs.applicantInformation) {
                        that.$refs.applicantInformation.setAvatarLoad(false);
                    }
                });
        },
        editApplicant() {
            const that = this;
            const formData = new FormData();
            let api = `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?updateApplicant`;

            // Parse array into string
            formData.append('data', JSON.stringify(this.currentItem));
            formData.append('mode', 'updateApplicant');

            // Post request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return JSON response
                    return response.json();
                })
                .then(function (json) {
                    // Success result
                    if (json.result.match(/OK/i)) {
                        that.$emit('setNotification', '#1dc9b7', 'mdi-account-edit', `The applicant has been successfully updated.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `You are not authorized to perform this action. Please refresh your application.`, true);
                    } else {
                        that.$emit('setNotification', '#ffb822', 'mdi-folder-alert', `The applicant could not be updated. ${json.message}.`, true);
                    }

                    that.refreshData();
                })
                .catch(function () {
                    that.refreshData();
                    that.$emit('setNotification', '#f64e60', 'mdi-alert-circle', `An error occurred. Please contact your system administrator.`, true);
                });
        },
        getAccess() {
            if (this.permission.enabled == "1" && this.permission.access == "write") {
                return true;
            }

            return false;
        },
        getApplicantRole(item) {
            if (item.hasOwnProperty('applicantRole') && item.applicantRole == "residenceAssistant") {
                return 'Residence Assistant';
            } else if (item.hasOwnProperty('applicantRole') && item.applicantRole == "student") {
                return 'Student';
            }

            return 'N/A';
        },
        getCurrentApplicant() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplicant&id=${this.currentItem.id}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        // Check if the user is return
                        if (json.data[0]) {
                            that.currentItem = json.data[0];
                        }
                    }
                })
                .catch(function () {})
        },
        getPrintedColor(item) {
            if (item.officeUse.hasOwnProperty('printed') && item.officeUse.printed == "1") {
                return '#1bc5bd';
            } else if (item.officeUse.hasOwnProperty('printed') && item.officeUse.printed == "0") {
                return '#ffa800';
            }

            return '#3f4254';
        },
        getPrintedLabel(item) {
            if (item.officeUse.hasOwnProperty('printed') && item.officeUse.printed == "1") {
                return 'Yes';
            } else if (item.officeUse.hasOwnProperty('printed') && item.officeUse.printed == "0") {
                return 'No';
            }

            return 'N/A';
        },
        getResidenceTerm() {
            return this.residenceTerm;
        },
        getSearchTerm() {
            return this.searchTerm;
        },
        getStatusColor(item) {
            if (item.officeUse.hasOwnProperty('applicationStatus') && item.officeUse.applicationStatus == "In-process") {
                return '#3699ff';
            } else if (item.officeUse.hasOwnProperty('applicationStatus') && item.officeUse.applicationStatus == "Waiting list") {
                return '#ffa800';
            } else if (item.officeUse.hasOwnProperty('applicationStatus') && item.officeUse.applicationStatus == "Completed") {
                return '#1bc5bd';
            } else if (item.officeUse.hasOwnProperty('applicationStatus') && item.officeUse.applicationStatus == "Withdrawn") {
                return '#5578eb';
            }

            return '#3f4254';
        },
        getStatusLabel(item) {
            if (item.officeUse.hasOwnProperty('applicationStatus') && item.officeUse.applicationStatus) {
                return item.officeUse.applicationStatus;
            }

            return 'Applied';
        },
        openDialog(item) {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplicant&id=${item.id}`;

            // Default settings
            this.setLoader(true);
            this.$refs.applicantsManager.loading = true;
            this.$refs.applicantInformation.resetTab();
            this.$refs.applicantInformation.setAvatarLoad(true);
            this.currentAvatar = '';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        // Check if the user is return
                        if (json.data[0]) {
                            that.currentItem = json.data[0];
                            //that.getAvatar(that.currentItem.studentnumber);
                            that.dialog = true;
                        } else {
                            that.setNotification('#ffb822', 'mdi-account-circle', `The applicant could not be found. Either the ID is invalid or the applicant does not exist.`, true);
                        }
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `The specified applicant data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.setLoader(false);
                    that.$refs.applicantsManager.loading = false;
                })
                .catch(function () {
                    that.setLoader(false);
                    that.$refs.applicantsManager.loading = false;
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. The specified applicant data could not be retrieved. Please contact your system administrator.`, true);
                })
        },
        openDialogEdit(item) {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplicant&id=${item.id}`;

            // Default settings
            this.setLoader(true);
            this.$refs.applicantsManager.loading = true;
            this.$refs.applicantEdit.setAvatarLoad(true);
            this.$refs.applicantEdit.resetTab();
            this.currentAvatar = '';

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        // Check if the user is return
                        if (json.data[0]) {
                            that.currentItem = json.data[0];
                            //that.getAvatar(that.currentItem.studentnumber);
                            that.formSettings = json.formSettings;
                            that.residenceTermsAppliedTo = json.residenceTermsAppliedTo || [];
                            that.dialogEdit = true;
                        } else {
                            that.setNotification('#ffb822', 'mdi-account-circle', `The applicant could not be found. Either the ID is invalid or the applicant does not exist.`, true);
                        }
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else if (!json.result.match(/OK/i)) {
                        that.setNotification('#ffb822', 'mdi-alert-circle', `The specified applicant data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.setLoader(false);
                    that.$refs.applicantsManager.loading = false;
                })
                .catch(function () {
                    that.setLoader(false);
                    that.$refs.applicantsManager.loading = false;
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. The specified applicant data could not be retrieved. Please contact your system administrator.`, true);
                })
        },
        openReleaseOfInformation(item) {
            this.$router.push({
                path: `/forms/release-of-information/${item.roiExists.username}`
            });
        },
        refreshData() {
            this.$emit('refreshData');
        },
        removeTrainingDayMissed(index) {
            this.currentItem.trainingDaysMissed.splice(index, 1);
        },
        resetApplicant() {
            this.$refs.applicantsManager.loading = true;
            this.$refs.resetBtn.loading = true;

            // Reset form validation and form fields
            if (this.$refs.applicantsManagerSearch) {
                this.$refs.applicantsManagerSearch.resetValidation();
            }

            this.residenceTerm = this.residenceTermDefault;
            this.searchTerm = '';
            this.setSearch(false);
            this.refreshData();
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.applicantsManager.loading = false;
                    this.$refs.resetBtn.loading = false;
                }, 1000);
            })
        },
        resetBuildingOption1() {
            this.currentItem.buildingOption01 = '';
        },
        resetBuildingOption2() {
            this.currentItem.buildingOption02 = '';
        },
        resetRoommateOption1() {
            this.currentItem.roommateRequest01 = [];
        },
        resetRoommateOption2() {
            this.currentItem.roommateRequest02 = [];
        },
        searchApplicant() {
            const that = this;
            let api =
                `https://${location.hostname}/cgi-bin/res-app-api/controller.api.pl?getApplicants&residenceTerm=${this.residenceTerm}&search=${this.searchTerm}`;

            this.$refs.applicantsManager.loading = true;
            this.$refs.searchBtn.loading = true;
            this.setSearch(true);

            // GET request
            fetch(api)
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // Error handling
                    if (json.result.match(/OK/i)) {
                        that.$emit('setData', json.data);
                        that.setNotification('#1dc9b7', 'mdi-account-search', `Applicants search result: ${json.message}`, true);
                    } else if (json.message.match(/WARNING/i)) {
                        that.setNotification('#ffb822', 'mdi-account-alert', `Applicants search data could not be retrieved. Please contact your system administrator.`, true);
                    } else if (json.message.match(/UNAUTHORIZED/i)) {
                        that.setNotification('#f64e60', 'mdi-alert-circle', `You are not authorized to view this resource. Please refresh your application.`, true);
                    } else {
                        that.setNotification('#f64e60', 'mdi-account-alert', `An error occurred. Applicants search data could not be retrieved. Please contact your system administrator.`, true);
                    }

                    that.$refs.applicantsManager.loading = false;
                    that.$refs.searchBtn.loading = false;
                })
                .catch(function () {
                    that.$refs.applicantsManager.loading = false;
                    that.$refs.searchBtn.loading = false;
                    that.setNotification('#f64e60', 'mdi-alert-circle', `An error occurred. Applicants search data could not be retrieved. Please contact your system administrator.`, true);
                })
        },
        setActiveApplicant(item) {
            if (item) {
                this.openDialog(item);
            }
        },
        setLoader(bool) {
            this.$emit('setLoader', bool);
        },
        setNotification(color, icon, message, status) {
            this.$emit('setNotification', color, icon, message, status);
        },
        setResidenceTerm(term) {
            this.residenceTerm = term;
        },
        setSearch(bool) {
            this.$emit('setSearch', bool);
        }
    },
    computed: {
        getResidenceTerms() {
            let residences = [{
                    text: 'Active Residence Terms',
                    value: 'active'
                },
                {
                    text: 'All Residence Terms',
                    value: ''
                }
            ];

            if (this.residenceTerms && this.residenceTerms.length > 0) {
                residences = this.residenceTerms.concat(residences);
            }

            return residences;
        },
        infoColor() {
            return '#5578eb';
        },
        primaryColor() {
            return '#5867dd';
        },
        subAppColor() {
            return '#FFA800';
        },
        successColor() {
            return '#1dc9b7';
        },
        warningColor() {
            return '#ffb822'
        }
    }
}
</script>